
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexeyepSd7jITZ_YaNLcww6dhBBl7Yy7B4GtZfpsG_45xI0oMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/index.vue?macro=true";
import { default as indexeQ80YdwhP_eSvpWNWcVJfw1XdBmPf2JemY6XnR5WF3AMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/cart/index.vue?macro=true";
import { default as indexPHIJkJT6W0eRe7N_45EboS5xCXKJT_45uXDeMDWHuxFMOLcMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/login/index.vue?macro=true";
import { default as indexs3tjEGZUYuPQVBNsHpNoga6E4kIw283nbYzXhyyNH3YMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/logout/index.vue?macro=true";
import { default as indexkobL_Y7mEwn5WIoOqN_45xuOkL_45ObXAEnFTB5Q0tWqsnwMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/contact/index.vue?macro=true";
import { default as index_45BJPgzBB2uh8zjSXucIXy8VUChF6uKJaDvRF9ctn28EMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/checkout/index.vue?macro=true";
import { default as index0_y_3aL_45S3EgD_457bXtKvtElu7XlOEa2z0vbqkZ6uKXsMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/myorders/index.vue?macro=true";
import { default as indexacKPgHe_45_450h5O8LTCq5FNBMQ6_9nAQEgZ3eLHyZjdicMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/index.vue?macro=true";
import { default as index0G8GM450Wpm6xv_lNm9hFClDn8WJPWxxYcSHcLHHfQQMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/lookbooks/index.vue?macro=true";
import { default as listKJaXYdqMQxNCbA_45nuKsRSzVTXUMRuvrp5hAYkNERYqkMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/list.vue?macro=true";
import { default as indexXonSv_XUwx_455s4ymR4Ku8KZcJs7Kp1s2pReyRWd10TUMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/openOrders/index.vue?macro=true";
import { default as indexX13ERhaUNvue4NvodJ6MFl90HbgI6yGbW744WvDVBjcMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/index.vue?macro=true";
import { default as indexn_SalVTo0giAl2KoK7X5V0Sk2RA_ULRdYvMlzDMp8wAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/statements/index.vue?macro=true";
import { default as indexkBub5A6SyHTzCD7k7DG8aspZeew9ZSrzwAPW9IjiLYwMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/tradeshows/index.vue?macro=true";
import { default as indexmY_1_45CN_45WYtGoRfmaMHmLlLu2WRhzOyMol8YA_45QslA4Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/admin/login/index.vue?macro=true";
import { default as indexd9qyGg9bK78Vkc59_45YMvII40xUuEZAj2pXBe1LBbPA0Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/creditMemos/index.vue?macro=true";
import { default as _91promotionName_930VThHovD82yQ1sSDv8wQcL1ouwO_cuCeOh74fkxfeSYMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/p/[promotionName].vue?macro=true";
import { default as createS_RMhevLZJRzX5obOwBjKSfJJm8beJg7Chxrw0j9_45tUMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/create.vue?macro=true";
import { default as category8dfiI6_HzEuo8f1jLrzshhDXDVcTEYUSbWkRtykAVdYMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/category.vue?macro=true";
import { default as resetPasswordsSwr_RPjOnaj_45W1fYCHlF5jueSJWkrYnG0scLo6gsR0Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/user/resetPassword.vue?macro=true";
import { default as list2Zmjo_45BsW_45yuvqrZs_45PhDEAYtrTeaLSVyP9WtU8yAZAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/list.vue?macro=true";
import { default as indexrk5btUZ2oV3MI6ao3ag3oxsCJf_W23MbI6FOObJnSNsMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/color/index.vue?macro=true";
import { default as index9ToFdOXlFqexIVmQrvjwAPUhc937YgbqnkkCpqJUrcQMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/index.vue?macro=true";
import { default as index1DUubo7NGGn8QLdlakvx4X_45VBLApCjVDSzxNVy6aASQMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/barcode/index.vue?macro=true";
import { default as _91productNo_93KJf_45WE9UTccsX_4o_45v5T76DAjQoguu6yMGCLeCtlQJEMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/[productNo].vue?macro=true";
import { default as colorAndSizeChartssVaCIEKYFhlRk_4546e2m45RmAaEMzN1F_GK_vZVMW9hAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/colorAndSizeCharts.vue?macro=true";
import { default as indexgqt_45iTJCBC_xdmcBjStUk_1YUdKd7Mat4gurNcB6rZsMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/sizeAndColor/index.vue?macro=true";
import { default as indextrHHkqprJaqtmqKBBybgE6odmKMaD5ntq4oDAexIZuMMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/PriceAndColorAndSize/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexeyepSd7jITZ_YaNLcww6dhBBl7Yy7B4GtZfpsG_45xI0oMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/cart/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: indexs3tjEGZUYuPQVBNsHpNoga6E4kIw283nbYzXhyyNH3YMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/logout/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/contact/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/checkout/index.vue")
  },
  {
    name: "myorders",
    path: "/myorders",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/myorders/index.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: indexacKPgHe_45_450h5O8LTCq5FNBMQ6_9nAQEgZ3eLHyZjdicMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/index.vue")
  },
  {
    name: "lookbooks",
    path: "/lookbooks",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/lookbooks/index.vue")
  },
  {
    name: "ra-support-list",
    path: "/ra-support/list",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/list.vue")
  },
  {
    name: "openOrders",
    path: "/openOrders",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/openOrders/index.vue")
  },
  {
    name: "ra-support",
    path: "/ra-support",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/index.vue")
  },
  {
    name: "statements",
    path: "/statements",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/statements/index.vue")
  },
  {
    name: "tradeshows",
    path: "/tradeshows",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/tradeshows/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/admin/login/index.vue")
  },
  {
    name: "creditMemos",
    path: "/creditMemos",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/creditMemos/index.vue")
  },
  {
    name: "p-promotionName",
    path: "/p/:promotionName()",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/p/[promotionName].vue")
  },
  {
    name: "ra-support-create",
    path: "/ra-support/create",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/ra-support/create.vue")
  },
  {
    name: "inventory-category",
    path: "/inventory/category",
    meta: category8dfiI6_HzEuo8f1jLrzshhDXDVcTEYUSbWkRtykAVdYMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/category.vue")
  },
  {
    name: "user-resetPassword",
    path: "/user/resetPassword",
    meta: resetPasswordsSwr_RPjOnaj_45W1fYCHlF5jueSJWkrYnG0scLo6gsR0Meta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/user/resetPassword.vue")
  },
  {
    name: "inventory-style-list",
    path: "/inventory/style/list",
    meta: list2Zmjo_45BsW_45yuvqrZs_45PhDEAYtrTeaLSVyP9WtU8yAZAMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/list.vue")
  },
  {
    name: "inventory-color",
    path: "/inventory/color",
    meta: indexrk5btUZ2oV3MI6ao3ag3oxsCJf_W23MbI6FOObJnSNsMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/color/index.vue")
  },
  {
    name: "inventory-style",
    path: "/inventory/style",
    meta: index9ToFdOXlFqexIVmQrvjwAPUhc937YgbqnkkCpqJUrcQMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/index.vue")
  },
  {
    name: "inventory-barcode",
    path: "/inventory/barcode",
    meta: index1DUubo7NGGn8QLdlakvx4X_45VBLApCjVDSzxNVy6aASQMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/barcode/index.vue")
  },
  {
    name: "inventory-style-productNo",
    path: "/inventory/style/:productNo()",
    meta: _91productNo_93KJf_45WE9UTccsX_4o_45v5T76DAjQoguu6yMGCLeCtlQJEMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/style/[productNo].vue")
  },
  {
    name: "inventory-colorAndSizeCharts",
    path: "/inventory/colorAndSizeCharts",
    meta: colorAndSizeChartssVaCIEKYFhlRk_4546e2m45RmAaEMzN1F_GK_vZVMW9hAMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/colorAndSizeCharts.vue")
  },
  {
    name: "inventory-sizeAndColor",
    path: "/inventory/sizeAndColor",
    meta: indexgqt_45iTJCBC_xdmcBjStUk_1YUdKd7Mat4gurNcB6rZsMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/sizeAndColor/index.vue")
  },
  {
    name: "inventory-PriceAndColorAndSize",
    path: "/inventory/PriceAndColorAndSize",
    meta: indextrHHkqprJaqtmqKBBybgE6odmKMaD5ntq4oDAexIZuMMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB/src/pages/inventory/PriceAndColorAndSize/index.vue")
  }
]